import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Button} from 'views/components';

import {Translate, translate} from 'views/module';
import {ErrorOutline} from 'views/icons';

import BiographyQuestionGroup from './view/BiographyQuestionGroup';
import BioDefaults from './BioDefaults';

const Biography = (props) => {
  const [loadingExport, setLoadingExport] = React.useState(false);

  const caregiverBioQuestions = props.caregiverBioQuestions;
  const caregiverBackend = props.caregiverBackend;
  const caregiverData = props.caregiverData;

  const {updateQuestion, updateMultipleQuestions, getSignedReadUrl} = caregiverBackend.bioQuestions;

  const fullQuestions = Object.fromEntries(Object.entries(BioDefaults.Questions)
      .map(([category, questions]) => {
        const newQuestions = questions.map((question) => (caregiverBioQuestions.questions[question.bioQuestionId] ?? question));
        return [category, newQuestions];
      }),
  );

  const formatCaregiverToFramer = async () => {
    const getQuestionValue = (category, bioQuestionId) => {
      return fullQuestions[category].find((question) => question.bioQuestionId === bioQuestionId).questionData.value;
    };


    const nameArray = getQuestionValue('personalInfo', 'name').trim().split(' ');
    const name = `${nameArray[0]} ${nameArray[nameArray.length-1].at(0)}.`;
    const profilePhotoUrl = await getSignedReadUrl(caregiverData.profileImg);
    return {
      'Headshot': {
        'url': profilePhotoUrl,
      },
      'CG Name': name,
      'Skills': 'Brief Changing Memory Care Medication Support Bathing House' +
      'keeping Overnight Care Mobility Support Dressing Meal Preparation Toiletting'+
      'Private Caregiving Long Term Care Hospital Homecare Retirement Home',
      'Experience': `${getQuestionValue('workExperience', 'yearsOfExperience') || '1'}+ Years`,
      'Expertise': 'Private Caregiving Long Term Care Hospital Homecare Retirement Home',
      'Languages': getQuestionValue('personalInfo', 'languagesSpoken').map((lang) => `${lang.at(0).toUpperCase()}${lang.slice(1)}`).join(' '),
      'Location': getQuestionValue('personalInfo', 'currentCity'),
      'Short Bio': getQuestionValue('personalInfo', 'shortBio'),
      'Personal Bio': getQuestionValue('personalInfo', 'personalBio'),
      'CG Motivation': getQuestionValue('personalInfo', 'caregiverMotivation'),
      'Youtube': '',
      'Nursing student': getQuestionValue('workQuali', 'caregiverType') === 'nursingStudent',
      'VSC Check': false,
      'Insured': true,
      'Featured': true,
      'Featured Position': 0,
    };
  };

  const exportCaregiver = async () => {
    setLoadingExport(true);
    try {
      const json = await formatCaregiverToFramer();
      const jsonString = JSON.stringify([json]);

      const blob = new Blob([jsonString], {type: 'application/json'});
      const blobUrl = URL.createObjectURL(blob);

      const downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;
      downloadLink.download = `Caregiver-${json['CG Name'].slice(0, -1).split(' ').join('-')}.json`;
      downloadLink.click();
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error(error);
    }
    setLoadingExport(false);
  };

  return (
    <Stack>
      <Stack sx={{p: 2}} spacing={2} >
        {
          Object.entries(fullQuestions).map(([category, questions]) => (
            <BiographyQuestionGroup
              key={category}
              title={translate(`caregiver.CaregiverDetail.Biography.Categories.${category}`)}
              bioQuestions={questions}
              icon={BioDefaults.CategoryIcons[category] || ErrorOutline}
              saveQuestion={updateQuestion}
              caregiverBackend={caregiverBackend}
              saveMultipleQuestions={updateMultipleQuestions}
            />
          ))
        }
      </Stack>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        <Button
          onClick={exportCaregiver}
          loading={loadingExport}
        >
          <Translate expression='caregiver.CaregiverDetail.Biography.Export' />
        </Button>
      </Box>
    </Stack>
  );
};

Biography.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  refresh: PropTypes.number.isRequired,
  caregiverBioQuestions: PropTypes.object.isRequired,
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};
export default React.memo(Biography);
